import { getTimezoneOffset } from "date-fns-tz";

import type { Timezone, TimezoneWithoutOffset } from "./timezoneTypes";

/**
 * Augment hard-coded timezone information stored in this package with its current offset relative to UTC,
 * adjusted for daylight saving using the current date.
 *
 * @see https://github.com/marnusw/date-fns-tz#gettimezoneoffset
 */
export function lookupTimezoneOffset(
  tz: TimezoneWithoutOffset,
  date?: Date,
): Timezone {
  const offsetInMs = getTimezoneOffset(tz.ianaCode, date);
  if (isNaN(offsetInMs)) {
    throw new Error(
      `Unable to lookup offset for invalid timezone '${tz.ianaCode}'`,
    );
  }

  const isPositiveOffset = offsetInMs >= 0;
  const offsetInMinutes = Math.abs(offsetInMs) / 1000 / 60;
  const offsetHours = Math.trunc(offsetInMinutes / 60)
    .toString()
    .padStart(2, "0");
  const offsetMinutes = (offsetInMinutes % 60).toString().padEnd(2, "0");
  return {
    ...tz,
    offset: `${isPositiveOffset ? "+" : "-"}${offsetHours}:${offsetMinutes}`,
  };
}
